<template>
    <el-skeleton :rows="12" :loading="loading" animated>
        <template #default>
            <el-form ref="formRef" :disabled="saving" :rules="rules" :model="product" label-position="top">
                <el-form-item prop="name" label="Nome do produto">
                    <el-input name="name" v-model="product.name" />
                </el-form-item>
                <el-row>
                    <el-col :xs="24" :md="12">
                        <el-form-item prop="price" label="Preço">
                            <el-input-number :step="0.0001" :min="0.001" name="price" v-model="product.price" />
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12">
                        <el-form-item prop="quantity" label="Quantidade em estoque">
                            <el-input-number :step="1" :min="0" name="quantity" v-model="product.quantity" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item prop="images" label="Selecione as imagens do produto">
                    <el-input multiple v-model="uris" type="file" ref="images" name="images" @change="selectImages" />
                </el-form-item>
    
                <el-form-item label="Selecionar categorias do produto" prop="categories">
                    <el-select v-model="product.categories" multiple>
                        <el-option :label="c.name" v-for="c in categories" :value="c.id" :key="c.id">{{ c.name }}</el-option>
                    </el-select>
                </el-form-item>

                <el-divider />
                <label>Epecifique algumas caracteristicas (opcionais)</label>

                <el-form-item :label="key" v-for="key in Object.keys(properties)" :key="key">
                    <el-input name="key" v-model="properties[key]" placeholder="Informe se aplicavel" />
                </el-form-item>
                <el-divider />

                <el-form-item label="Descrição" prop="description">
                    <el-input type="textarea" name="description" v-model="product.description" minlength="1" />
                </el-form-item>
        
                <el-button plain  :loading="saving" size="large" type="primary" @click.prevent="submit(formRef)">
                    Cadastrar
                </el-button>
            </el-form>
        </template>
    </el-skeleton>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { Category, Product } from "@/services/types"
    import { ElCol, ElMessage, ElMessageBox, ElRow, FormInstance, FormRules } from "element-plus"
    import { onBeforeMount, reactive, ref } from "vue"
    import { useRouter } from "vue-router"
    import { useStore } from "vuex"

    const store = useStore()
    const router = useRouter()
    const product = reactive<Product>({
        name: '',
        description: '',
        price: 0,
        categories: [],
        images: [],
        quantity: 1,
        promoction: 0,
    })

    const properties = ref<Record<string, string>>({
        Marca: '',
        'Modelo / Referência': '',
        Cor: '',
        'Tamanho / Dimensões': '',
        Peso: '',
        'Material / Composição': '',
        'Estado do produto': ''
    })

    const rules = reactive<FormRules<Product>>({
        name: [{required: true, message: 'Insira o nome do produto', min: 1}],
        categories: [
            {required: true, message: 'Selecione as categorias'}
        ],
        description: [{required: true, message: 'A descrição é obrigatória'}],
        images: [
            {required: true, message: 'Selecione as imagens', trigger: 'blur'}
        ],
        price: [
            {required: true, message: 'Indique o preco do produto'}
        ],
        quantity: [
            {required: true, message: "Informar quantidade disponivel"},
            // {min: 0, message: 'Maior que zero'}
        ]
    })

    const images = ref()
    const uris = ref<string>()
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const loading = ref<boolean>(true)
    
    const categories = reactive<Array<Category>>([])

    onBeforeMount(async () => {
        loading.value = true
        const res = await Api.get('admin/categories')
        console.log(res)
        if (res.status != 200) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message)
        } else {
            const data = res.data.categories
            categories.splice(0)
            data.forEach((element: Category) => {
                categories.push(element)
            });
        }
        loading.value = false
    })

    const selectImages = () => {
        console.log(images.value?.input.files)
        product.images?.splice(0)
        for (let i = 0; i < images.value?.input.files.length; i++) {
            product.images?.push(images.value?.input.files[i])
        }

        console.log(product.images)
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const data = new FormData()
                data.append('name', product.name)
                data.append('price', `${product.price}`)
                data.append('promoction', `${product.promoction}`)
                data.append('quantity', `${product.quantity}`)
                data.append('description', product.description)

                // categorias
                product.categories?.forEach((c, i) => {
                    data.append(`categories[${i}]`, c.toString())
                })

                // imagens
                product.images?.forEach((img: any, i) => {
                    data.append(`images[${i}]`, img)
                })

                // propriedades
                Object.keys(properties.value).forEach(prop => {
                    if (properties.value[prop] && properties.value[prop].trim().length > 0) {
                        data.append(`properties[${prop}]`, properties.value[prop])
                    }
                })

                const res = await Api.post('admin/products', product, data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Produtos cadastrado com sucesso'})
                    store.commit('setOpenModal', -1)
                    // router.push('/products')
                    // location.reload()
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>
